import { GenexStore, ModelWithCategory, OptionalUserData } from 'core/stores/genex.store';
import { useAppContext } from './index';

const useTriggerSurvey = () => {
  const appContext = useAppContext();

  const customerNumber = appContext.customerNumber || '';

  return (surveyModel: ModelWithCategory, optionalData?: OptionalUserData) => {
    if (optionalData) {
      GenexStore.saveUserData(optionalData)
    }

    console.log("Triggering survey:", surveyModel, "for customer:", customerNumber);
    GenexStore.triggerSurvey(surveyModel, customerNumber, new Date());
  };
}

export default useTriggerSurvey;